import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isToday from 'dayjs/plugin/isToday';
import isTomorrow from 'dayjs/plugin/isTomorrow';
import isYesterday from 'dayjs/plugin/isYesterday';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import i18n from 'i18n';

export { i18n };

export { default as classNames } from 'classnames';
export { useBottomScrollListener } from 'react-bottom-scroll-listener';
export {
  createRoutesFromChildren,
  matchPath,
  matchRoutes,
  Navigate,
  resolvePath,
  Route,
  Outlet as RouterOutlet,
  Routes,
  useLocation,
  useMatch,
  useNavigation,
  useNavigationType,
  useParams,
  useResolvedPath,
  useSearchParams,
} from 'react-router-dom';
export { CreatableProps } from 'react-select/creatable';
export {
  createGlobalStyle,
  css,
  keyframes,
  default as styled,
  ThemeProvider as StyledThemeProvider,
  useTheme,
} from 'styled-components';
export { default as cssResetStyles } from 'styled-reset';

export {
  Controller,
  FormProvider,
  useFieldArray,
  useForm,
  useFormContext,
  useWatch,
} from 'react-hook-form';
export type {
  Control,
  FieldError,
  FieldPath,
  UseFieldArrayProps,
  UseFormSetValue,
} from 'react-hook-form';
export { useTranslation } from 'react-i18next';
export { Provider, useDispatch, useSelector } from 'react-redux';
export {
  applyMiddleware,
  bindActionCreators,
  combineReducers,
  compose,
  legacy_createStore as createStore,
} from 'redux';
export { v4 as uuid } from 'uuid';

export { useCallbackRef } from 'use-callback-ref';

export {
  components as reactSelectComponents,
  default as Select,
} from 'react-select';
export {
  AsyncPaginate,
  withAsyncPaginate,
  wrapMenuList,
} from 'react-select-async-paginate';
export { default as AsyncSelect } from 'react-select/async';
export { default as AsyncCreatableSelect } from 'react-select/async-creatable';

dayjs.extend(isTomorrow);
dayjs.extend(isYesterday);
dayjs.extend(isToday);
dayjs.extend(isSameOrBefore);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
export { createTheme } from '@mui/material';
export { default as _ } from 'lodash';
export { IMask, IMaskInput } from 'react-imask';
export { useNavigate } from 'react-router';
export { dayjs };

export {
  SnackbarKey,
  SnackbarProvider,
  useSnackbar,
  VariantType,
} from 'notistack';

export { default as copyToClipboard } from 'copy-to-clipboard';

export { cloneDeep, getInputFromTemplate, Template } from '@pdfme/common';
export { Designer } from '@pdfme/ui';
export { default as printJS } from 'print-js';
export { default as AvatarEditor } from 'react-avatar-editor';
export { default as Dropzone } from 'react-dropzone';

export { default as Signature } from '@uiw/react-signature';
export {
  DragDropContext,
  Draggable,
  DraggableProvided,
  Droppable,
  DroppableProvided,
} from 'react-beautiful-dnd';

export { TourProvider, useTour } from '@reactour/tour';
export { default as copyTextToClipboard } from '@uiw/copy-to-clipboard';
export { default as JsonView } from '@uiw/react-json-view';
export {
  default as ContentLoader,
  Facebook as FacebookLoader,
} from 'react-content-loader';
